// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"551":"locale-en-json","841":"locale-ru-json"}[chunkId] + "." + {"551":"cdbdf6eb","841":"9ed63bb1"}[chunkId] + ".js";
};